import { Navigate, createBrowserRouter } from 'react-router-dom';
import OrderEntry from 'components/OrderEntry';
import PdfViewer from 'components/shared/PdfViewer';
import Layout from 'components/layouts/Layout';
import ApiOffline from 'components/layouts/ApiOffline';
import Login from 'components/login/Login';
import Body from 'components/layouts/Body';


export const menuRoutes = [
    {
        to: "/alliance/dashboard",
        icon: "fa-solid fa-spell-check",
        title: "Dashboard",
        description: "Dashboard view",
        component: <Body />
    },
    {
        to: "/alliance/login",
        icon: "fa-solid fa-spell-check",
        title: "Login",
        description: "Login page",
        component: <Login />
    },
    {
        to: "/alliance/order-entry/:id",
        icon: "fa-solid fa-spell-check",
        title: "Order Entry",
        description: "View orders details",
        component: <OrderEntry />
    },
    {
        to: "/alliance/pdf-viewer/:id",
        icon: "fa-solid fa-code-compare",
        title: "PDF Viewer",
        description: "View PDF files",
        component: <PdfViewer />
    },
];


export const router = createBrowserRouter([
    {
        id: "root",
        path: "/alliance",
        element: <Layout />,
        errorElement: <ApiOffline />,
        children: [
            {
                index: true,
                element: <Navigate to='/alliance/dashboard' />,
            },
            ...menuRoutes.map((route) => ({
                path: route.to,
                element: route.component,
            })),
            {
                path: "login",
                element: <Navigate to={menuRoutes[1].to} />
            },
            {
                path: "*",
                element: <Navigate to={'alliance'} />,
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to={'alliance'} />,
    },
]);